import { NaicsCodeEntity } from '../../Models/Api/strongbox.financialportal';

import { GetBasicNaicsCodes } from '../../Services/Industries';

import { LogException } from '../../Utils/Logging';

import {
    AppThunkActionAsync
} from '../index';
import { KnownAction as uiKnownActions, actionCreators as uiStateActions } from '../UIState';
import {
    IndustriesActions,
    KnownAction,
} from './Actions';

/**
 * Loads the full list of basic NAICS codes from the back end. Intended to be called when the
 * "Run Audit Workpapers" button is pressed; it only actually fetches the first time -
 * subsequent calls are a no-op while a load is in flight or once one has completed.
 */
const LoadIndustries = (): AppThunkActionAsync<NaicsCodeEntity[], KnownAction | uiKnownActions> =>
    async (dispatch, getState): Promise<NaicsCodeEntity[]> => {
        const industriesState = getState().industries;

        // Only load the first time - skip if a load is in flight or has already completed.
        if (industriesState && (industriesState.loaded || industriesState.loading)) {
            return industriesState.naicsCodes;
        }

        const workingName = `LoadIndustries`;

        dispatch(uiStateActions.SetPortalWorking(workingName));

        try {
            dispatch({ type: IndustriesActions.LoadStart });

            const naicsCodes = await GetBasicNaicsCodes();

            dispatch({
                type: IndustriesActions.LoadComplete,
                naicsCodes,
            });

            return naicsCodes;
        } catch (e) {
            const errorMsg = 'Loading industries action creator failed';

            console.error(errorMsg);
            console.error(e);

            LogException(errorMsg, e);

            dispatch({
                type: IndustriesActions.LoadError,
                error: errorMsg,
            });

            return [];
        } finally {
            dispatch(uiStateActions.SetPortalIdle(workingName));
        }
    }

export const actionCreators = {
    LoadIndustries,
};
